import { render, staticRenderFns } from "./KeyPerformanceIndicator.vue?vue&type=template&id=a322f230"
import script from "./KeyPerformanceIndicator.vue?vue&type=script&lang=js"
export * from "./KeyPerformanceIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports